import { TermsOfUse } from 'components/terms';
const TermsOfUseContainer = TermsOfUse;
export { TermsOfUseContainer };
